import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { useStore } from '../../context/StoreContext';

import AdminVideos from './AdminVideos';
import AdminLive from './AdminLive';
import AdminAds from './AdminAds';

const AdminLogin = () => {
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const { loginAdmin } = useStore();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!loginAdmin(pwd)) setError('Invalid password. Hint: Rocketalgo@123');
  };

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-4">
      <div className="bg-dark-surface border border-dark-border p-8 rounded-xl w-full max-w-md">
        <div className="flex justify-center mb-6">
          <SafeIcon name="Shield" className="w-12 h-12 text-rocket" />
        </div>
        <h2 className="text-2xl font-bold text-center mb-6">Admin Access</h2>
        <form onSubmit={handleLogin}>
          <input 
            type="password" 
            value={pwd}
            onChange={e => setPwd(e.target.value)}
            placeholder="Admin Password"
            className="w-full bg-dark-card border border-dark-border rounded-md px-4 py-3 mb-4 focus:outline-none focus:border-rocket"
          />
          {error && <p className="text-danger text-sm mb-4">{error}</p>}
          <button 
            type="submit"
            className="w-full bg-rocket hover:bg-rocket-hover text-white py-3 rounded-md font-bold transition-colors"
          >
            Login
          </button>
        </form>
        <Link to="/" className="block text-center text-muted text-sm mt-4 hover:text-white">Return to Site</Link>
      </div>
    </div>
  );
};

const AdminLayout = () => {
  const { isAdmin, logoutAdmin } = useStore();
  const location = useLocation();

  if (!isAdmin) return <AdminLogin />;

  const navItems = [
    { path: '/admin', icon: 'Film', label: 'Videos & Series' },
    { path: '/admin/live', icon: 'Radio', label: 'Viloud Live Streams' },
    { path: '/admin/ads', icon: 'Megaphone', label: 'Ads & Hero' },
  ];

  return (
    <div className="flex h-screen bg-dark-bg overflow-hidden">
      {/* Sidebar */}
      <div className="w-64 bg-dark-surface border-r border-dark-border flex flex-col">
        <div className="p-6 border-b border-dark-border flex items-center space-x-2">
          <SafeIcon name="TrendingUp" className="w-6 h-6 text-rocket" />
          <span className="font-bold text-xl">Admin<span className="text-rocket">Panel</span></span>
        </div>
        
        <nav className="flex-1 py-6 px-4 space-y-2">
          {navItems.map(item => (
            <Link 
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                location.pathname === item.path 
                  ? 'bg-rocket/10 text-rocket border border-rocket/20' 
                  : 'text-muted hover:bg-dark-card hover:text-white'
              }`}
            >
              <SafeIcon name={item.icon} className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t border-dark-border space-y-2">
          <a href="/#/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 w-full py-2 bg-dark-card border border-dark-border rounded-md text-sm hover:bg-dark-surface transition-colors">
            <SafeIcon name="ExternalLink" className="w-4 h-4" />
            <span>View Site</span>
          </a>
          <button onClick={logoutAdmin} className="flex items-center justify-center space-x-2 w-full py-2 text-danger hover:bg-danger/10 rounded-md text-sm transition-colors">
            <SafeIcon name="LogOut" className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-8">
        <Routes>
          <Route path="/" element={<AdminVideos />} />
          <Route path="/live" element={<AdminLive />} />
          <Route path="/ads" element={<AdminAds />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminLayout;